import './ListStats.scss';
import Component from './ListStats.js';
export default Component;
